<script setup>
import { useRouter } from 'vue-router';
import { delete_token } from '@/services/auth'
import { ref, onMounted } from 'vue';

const user = ref({name: '', type: 'customer'})
onMounted(()=>{
  let userData = JSON.parse(localStorage.getItem('user_data'))
  user.value.name = capitalizeWords(`${userData.first_name} ${userData.last_name}`)
})

function capitalizeWords(str) {
  return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

const router = useRouter()

async function logout (){
  let response = await delete_token()
  if (response.result.status == 200){
    router.replace({name: 'login'});
  }
}

function getUserType(type){
  if (type == 'customer'){
    return 'user'
  }
  return type
}
</script>

<template>
  <li class="profile-nav onhover-dropdown pe-0 py-0">
    <div class="profile-wrapper">
      <div class="media profile-media">
        <!-- <img class="b-r-10" src="@/assets/images/dashboard/profile.png" alt="" /> -->
        <div class="media-body ms-0">
          <span class="text-white">{{ user.name }}</span>
          <p class="mb-0 font-roboto text-capitalize text-white">
            {{ getUserType(user.type) }} <i class="middle fa fa-angle-down"></i>
          </p>
        </div>
      </div>
    </div>
    <ul class="profile-dropdown onhover-show-div">
      <li>
        <router-link :to="{name: 'profile'}">
          <vue-feather type="user"></vue-feather>
          <span class="text-capitalize">Account </span>
        </router-link>
      </li>
      <!-- <li>
        <vue-feather type="mail"></vue-feather><span>Inbox</span>
      </li> -->
      <!-- <li>
        <vue-feather type="file-text"></vue-feather><span>Taskboard</span>
      </li> -->
      <!-- <li>
        <vue-feather type="settings"></vue-feather><span>Settings</span>
      </li> -->
      <li  @click="logout()">
        <vue-feather type="log-in"></vue-feather><span>Log out</span>
      </li>
    </ul>
  </li>
</template>


